// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4308":"727973242bb33abd","6840":"6f05ebba79ec67b1"}[chunkId] + ".css";
};